angular.module('sidebar.module', []);

require('./sidebar-container/sidebar-container.component');
require('./sidebar-panel/sidebar-panel.component');